const STORAGE_KEY = 'cursorAgent.preferences';
const LEGACY_REPO_KEY = 'cursorAgent.repoUrl';

export type CursorAgentPreferences = {
  apiKey: string;
  repoUrl: string;
  /** WorkosCursorSessionToken — powers live billing/usage via dashboard API proxy. */
  sessionToken: string;
  /** Optional Enterprise admin API key (admin:*) for /teams/spend. */
  adminApiKey: string;
};

const DEFAULTS: CursorAgentPreferences = {
  apiKey: '',
  repoUrl: '',
  sessionToken: '',
  adminApiKey: '',
};

export function loadCursorAgentPreferences(): CursorAgentPreferences {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    let prefs: CursorAgentPreferences = { ...DEFAULTS };
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<CursorAgentPreferences>;
      prefs = {
        apiKey: typeof parsed.apiKey === 'string' ? parsed.apiKey : '',
        repoUrl: typeof parsed.repoUrl === 'string' ? parsed.repoUrl : '',
        sessionToken: typeof parsed.sessionToken === 'string' ? parsed.sessionToken : '',
        adminApiKey: typeof parsed.adminApiKey === 'string' ? parsed.adminApiKey : '',
      };
    }
    if (!prefs.repoUrl) {
      const legacy = localStorage.getItem(LEGACY_REPO_KEY)?.trim() ?? '';
      if (legacy) prefs.repoUrl = legacy;
    }
    return prefs;
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveCursorAgentPreferences(prefs: CursorAgentPreferences): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  try {
    if (prefs.repoUrl.trim()) {
      localStorage.setItem(LEGACY_REPO_KEY, prefs.repoUrl.trim());
    } else {
      localStorage.removeItem(LEGACY_REPO_KEY);
    }
  } catch {
    /* ignore */
  }
}
